import { ReactNode } from 'react';
import styled from '@emotion/styled';
import { withTheme } from '@mui/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import { StyledContainer } from './styled-components';
import { Header } from './header';

import { SIDE_IMAGE_BIG, SIDE_IMAGE_SMALL } from '@selfserve/react-utils';

const StyledLayoutContainer = styled(StyledContainer)`
  min-height: 100vh;
  flex-direction: row;
`;

const StyledChildrenContainer = styled(StyledContainer)`
  min-height: calc(100vh - 48px);
  height: auto;
  flex: 1;
`;

const StyledBgChildrenContainer = styled(StyledContainer)`
  min-height: calc(100vh - 48px);
  height: auto;
  flex: 1;
  background-color: #FFFFFF;
`;

const StyledSideImage = styled.div(({ theme }: { theme?: any }) => ({
  flex: `0 0 ${SIDE_IMAGE_BIG}px`,
  backgroundImage: 'url("assets/side-image.svg")',
  backgroundSize: '100%',
  backgroundPosition: 'center',
  [theme.breakpoints.down('lg')]: {
    flexBasis: `${SIDE_IMAGE_SMALL}px`,
  },
  backgroundRepeat: 'no-repeat',
}));

interface Props {
  children: ReactNode;
  showSideImage?: boolean;
  displayName?: string;
  theme?: any;
}

interface SplitScreenProps {
  children: ReactNode;
  secondScreen: ReactNode;
  displayName?: string;
  theme?: any;
}

const CommonLayout = withTheme(
  ({ children, showSideImage, theme, ...rest }: Props) => {
    const matchesMd = useMediaQuery(theme.breakpoints.down('md'));

    return (
      <StyledLayoutContainer>
        <StyledChildrenContainer>
          <Header {...rest} />
          {children}
        </StyledChildrenContainer>
        {showSideImage && !matchesMd && (
          <StyledSideImage className="meetings-icon" />
        )}
      </StyledLayoutContainer>
    );
  }
);

const SplitScreenLayout = withTheme(
  ({ children, secondScreen, theme, ...rest }: SplitScreenProps) => {
    const matchesMd = useMediaQuery(theme.breakpoints.down('md'));

    return (
      <StyledLayoutContainer>
        <StyledBgChildrenContainer>
          <Header {...rest} />
          {children}
        </StyledBgChildrenContainer>
        {!matchesMd && secondScreen}
      </StyledLayoutContainer>
    );
  }
);

export { CommonLayout, SplitScreenLayout, StyledSideImage };
